import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Form, useForm, isEmpty } from '../../../../form'
import { useHistory } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import {
  goToReview,
  getInvoiceUserEmail,
  getUserCompanyUpdateInfo,
  closeInvoiceFormDialog,
  cancelEditInvoice,
  saveInvoiceDraft
} from '../../../../actions'
import Dropzone from '../../../../utils/dropzone'
import Button from '@material-ui/core/Button'
import { useTranslation } from 'react-i18next'
import mobileView from '../../../../utils/mobile.utils'
import classNames from 'classnames'
import VerificationAlertDialog from '../../../layout/verificationAlertDialog'
import { Controller } from 'react-hook-form'

const styles = (theme) => ({
  button: {
    margin: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      margin: '8px 10px'
    }
  },
  buttonBack: {
    padding: !mobileView ? '2px 30px' : '4px 20px',
    fontWeight: '600',
    fontSize: '15px',
    color: 'rgb(83 77 77)',
    backgroundColor: '#fff',
    border: '2px solid #44C0CC',
    borderRadius: mobileView ? '4px' : '10px',
    cursor: 'pointer',
    [theme.breakpoints.down('375')]: {
      padding: '1px 12px'
    },
    '&:hover': {
      backgroundColor: '#E0F7FA'
    }
  }
})

const InvoiceAttachmentsForm = ({
  classes,
  goBack,
  formValues,
  updateFormValues
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const [showPopupVerification, setShowPopupVerification] = useState(false)
  const [invoiceValues, setInvoiceValues] = useState(false)

  const isEdit = useSelector((state) => state.invoice.isEdit)
  const user = useSelector((state) => state.profile.userData)

  const form = useForm({
    name: 'invoice',
    onSubmit: onSubmit,
    defaultValues: formValues,
    keepEmptyValuesOnSubmit: false
  })

  useEffect(() => {
    form.reset(formValues)
  }, [formValues])

  const {
    formState: { errors }
  } = form

  const [attemptingSubmit, setAttemptingSubmit] = React.useState(false)

  function onSubmit(values) {
    const valuesWithoutAttachments = { ...values, attachments: [] }
    updateFormValues(valuesWithoutAttachments)

    if (!user.is_verified) {
      setInvoiceValues(valuesWithoutAttachments)
      setShowPopupVerification(true)
    } else {
      dispatch(closeInvoiceFormDialog())
      dispatch(goToReview(valuesWithoutAttachments))
      history.push('/dashboard/invoice/review')
    }
  }

  React.useEffect(() => {
    if (attemptingSubmit && !isEmpty(errors)) {
      setAttemptingSubmit(false)
    }
  }, [attemptingSubmit, errors])

  React.useEffect(() => {
    dispatch(getInvoiceUserEmail(0))
    dispatch(getUserCompanyUpdateInfo())
  }, [])

  const saveInvDraft = () => {
    dispatch(saveInvoiceDraft(invoiceValues))
  }

  return (
    <Form
      {...form}
      style={{
        display: 'flex',
        height: '100%',
        flexDirection: 'column'
      }}
    >
      <div
        className="row"
        style={{
          flex: '1 1 auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: '-20px'
        }}
      >
        <div
          className="col-xs-12 col-sm-12 col-lg-12"
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <div
            className="panel panel-default"
            style={{ backgroundColor: 'white', boxShadow: 'none' }}
          >
            <div
              className="panel-body"
              style={{
                margin: !mobileView ? '0 25px' : '',
                padding: mobileView ? '0 20px' : ''
              }}
            >
              <h3
                style={{
                  textAlign: 'center',
                  fontSize: mobileView && '20px',
                  fontWeight: '600',
                  color: '#000',
                  textTransform: 'none',
                  marginBottom: !mobileView ? '50px' : '20px'
                }}
              >
                {t('invoice.attachmentTitle')}
              </h3>
              <Controller
                name="attachments"
                control={form.control}
                render={({ field: { value, onChange } }) => (
                  <Dropzone formFiles={value} setFormFiles={onChange} />
                )}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: mobileView ? '0' : '0 20px'
        }}
      >
        {isEdit ? (
          <>
            <Button
              variant="outlined"
              className={classes.button}
              onClick={(e) => {
                dispatch(closeInvoiceFormDialog())
                dispatch(cancelEditInvoice(e))
              }}
            >
              {t('invoice.button')}
            </Button>
          </>
        ) : (
          <>
            <Button
              className={classNames(classes.buttonBack, classes.button)}
              onClick={() => goBack(form.getValues())}
            >
              {t('asiakkaat.back')}
            </Button>
          </>
        )}
        <div style={{ display: 'flex' }}>
          {isEdit ? (
            <>
              <Button
                className={classNames(classes.buttonBack, classes.button)}
                onClick={() => goBack(form.getValues())}
              >
                {t('asiakkaat.back')}
              </Button>
            </>
          ) : null}
          <>
            <Button
              variant="contained"
              className={classes.button}
              onClick={() => setAttemptingSubmit(true)}
              type="submit"
            >
              {t('invoice.preview')}
            </Button>
          </>
        </div>
      </div>
      {showPopupVerification ? (
        <VerificationAlertDialog
          open={showPopupVerification}
          close={() => setShowPopupVerification(false)}
          saveInvoice={() => saveInvDraft()}
        />
      ) : null}
    </Form>
  )
}

export default withStyles(styles)(InvoiceAttachmentsForm)
